import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, IconButton } from '@mui/material';
import { ClassNameMap, makeStyles } from '@mui/styles';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import GetAppIcon from '@mui/icons-material/GetApp';
import { Collector, CollectorType } from 'graphql/types';
import { CollectorScope } from 'graphql/types';
import { useHandleDisconnect } from './hooks';

type SettingLinkProps = {
  onClose: () => void;
  scope: CollectorScope;
  collectorItem: Collector;
  collectorActionTitle?: string | React.ReactNode;
  showIcon?: boolean;
  classes?: ClassNameMap;
};

const useStyles = makeStyles((theme) => ({
  disconnect: {
    marginRight: 'auto'
  },
  desktopLink: {
    marginRight: 'auto',
    paddingLeft: theme.spacing(1),
    marginLeft: theme.spacing(1)
  },
  disconnectIcon: {
    paddingRight: theme.spacing(1)
  }
}));

export const SettingLink: React.FC<SettingLinkProps> = ({
  classes: overrideClasses,
  collectorItem,
  onClose,
  scope,
  collectorActionTitle = <FormattedMessage id="collectorSetting.downLoad" />,
  showIcon = true
}: SettingLinkProps) => {
  const classes = useStyles({ classes: overrideClasses });
  const { type } = collectorItem;
  const isDesktop = type === CollectorType.Desktop;
  const isPlugin = type === CollectorType.Plugin;
  const onDisconnect = useHandleDisconnect({ onClose, scope });
  const desktopLink =
    collectorItem.installURL ||
    'https://drive.google.com/drive/u/0/folders/1mhE3Ad6vWvplJfoNAKDQWQ_0Z37tgziD';

  return isDesktop || isPlugin ? (
    <Link
      href={desktopLink}
      target="_blank"
      color="primary"
      underline="none"
      onClick={onClose}
      className={classes.desktopLink}
    >
      {collectorActionTitle}
      {showIcon && (
        <IconButton
          aria-label="uninstall"
          size="medium"
          color="primary"
          className={classes.disconnectIcon}
          data-testid={'link-icon-' + collectorItem.name}
        >
          <GetAppIcon />
        </IconButton>
      )}
    </Link>
  ) : (
    <Link
      href="#"
      color="primary"
      underline="none"
      className={classes.disconnect}
      onClick={onDisconnect(collectorItem)}
    >
      {showIcon && (
        <IconButton
          aria-label="uninstall"
          size="medium"
          color="primary"
          data-testid={'uninstall-button-' + collectorItem.name}
          className={classes.disconnectIcon}
        >
          <LinkOffIcon />
        </IconButton>
      )}
      <FormattedMessage id="collectorSetting.uninstall" />
    </Link>
  );
};
